export default "__VITE_ASSET__aVegP342__"